export default __webpack_public_path__ + "static/media/design.ab3b78ab.png";